import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
	root: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit * 2
	}
})

const PageLabel = ({ classes, children, color }) => {
	return (
		<Typography
			className={classes.root}
			variant="display1"
			component="h1"
			align="center"
			style={{
				color: color
			}}
		>
			{children}
		</Typography>
	)
}

export default withStyles(styles)(PageLabel)



// WEBPACK FOOTER //
// ./src/components/PageLabel/index.js